import React, { Component } from 'react';
import { Tooltip } from 'reactstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faQuestionCircle } from '@fortawesome/free-solid-svg-icons'

class MyTooltip extends Component {
    state = {
        tooltipOpen: false
    }

    toggle = () => {
        this.setState({
            tooltipOpen: !this.state.tooltipOpen
        });
    }

    render() {
        const { name, message } = this.props;
        return (
            <React.Fragment>
                <span href='#' id={`${name}-tooltip`} className='tooltip-span' style={{ marginLeft: 5 }}>
                    <FontAwesomeIcon className="icon" icon={faQuestionCircle} />
                </span>
                <Tooltip isOpen={this.state.tooltipOpen} toggle={this.toggle} placement='right' target={`${name}-tooltip`}>{message}</Tooltip>
            </React.Fragment>
        );
    }
}

export default MyTooltip;